import React, { useEffect } from "react";
import Pagination from "@material-ui/lab/Pagination/Pagination";
import PropTypes from "prop-types";
import './style.scss';
const PaginationComponent = ({ count, page, handleChange }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  return (
    <div className="d-flex justify-content-center">
      <Pagination
        count={count}
        page={page}
        onChange={handleChange}
        showFirstButton
        showLastButton
        variant="outlined" shape="rounded"
        className="pag"
      />
    </div>
  );
};
export default PaginationComponent;
PaginationComponent.prototypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  handleChange: PropTypes.func,
};
